// Wiki（灵智原生的知识增强自动整理出来的：概念、实体、资料摘要、索引）。接口回的不包在 data 里。
import { request } from './client'

export type WikiType = 'index' | 'concept' | 'entity' | 'summary' | string
export const WIKI_TYPE_LABEL: Record<string, string> = { index: '索引', concept: '概念', entity: '实体', summary: '资料摘要' }

export interface WikiPage {
  id: string
  slug: string
  title: string
  page_type: WikiType
  status?: string
  content?: string
  summary?: string
  aliases?: string[]
  category_path?: string[]
  wiki_path?: string
  folder_id?: string
  /** 资料 id */
  source_refs?: string[]
  in_links?: string[]
  out_links?: string[]
  updated_at?: string
}
export interface WikiStats {
  total_pages: number
  pages_by_type: Record<string, number>
  total_links: number
  orphan_count?: number
}
export interface WikiFolder {
  id: string
  parent_id: string
  name: string
  path: string
  page_count: number
  has_children: boolean
}
export interface WikiIndex {
  intro: string
  groups: { type: WikiType; total: number; items: { slug: string; title: string; summary: string }[] }[]
}

const base = (kb: string) => `/knowledgebase/${encodeURIComponent(kb)}/wiki`
/** slug 里有「/」（concept/xxx）：每一段分别编码。 */
export const slugPath = (slug: string) => slug.split('/').map(encodeURIComponent).join('/')

export const wikiStats = (kb: string) => request<WikiStats>(`${base(kb)}/stats`)
export const wikiIndex = (kb: string, limit = 12) => request<WikiIndex>(`${base(kb)}/index`, { query: { limit } })
export const wikiFolders = (kb: string, parentId = '', types?: string) =>
  request<{ folders: WikiFolder[] }>(`${base(kb)}/folders`, { query: { parent_id: parentId, page_types: types } }).then((r) => r.folders ?? [])
export const wikiPages = (kb: string, q: { type?: string; folderId?: string; page?: number; pageSize?: number }) =>
  request<{ pages: WikiPage[]; total: number; page: number; page_size: number }>(`${base(kb)}/pages`, {
    query: { page_type: q.type || undefined, folder_id: q.folderId, page: q.page ?? 1, page_size: q.pageSize ?? 30, sort_by: 'title', sort_order: 'asc' },
  })
export const wikiPage = (kb: string, slug: string) => request<WikiPage>(`${base(kb)}/pages/${slugPath(slug)}`)
export const wikiSearch = (kb: string, q: string, limit = 20) => request<{ pages: WikiPage[] }>(`${base(kb)}/search`, { query: { q, limit } }).then((r) => r.pages ?? [])

/** 正文里的 [[slug|显示的字]] / [[slug]] 换成 Markdown 链接（wiki: 开头，阅读页里接成站内跳转）。代码块里的不动。 */
export function wikiLinks(md: string): string {
  return md
    .split(/(```[\s\S]*?```)/g)
    .map((part) => (part.startsWith('```') ? part : part.replace(/\[\[([^\]|]+?)(?:\|([^\]]+?))?\]\]/g, (_, slug: string, label?: string) => `[${(label ?? slug.split('/').pop() ?? slug).replace(/[[\]]/g, '')}](wiki:${slug.trim()})`)))
    .join('')
}
